import { render, staticRenderFns } from "./ModalEditSpaceChannels.vue?vue&type=template&id=3a7e9af4"
import script from "./ModalEditSpaceChannels.vue?vue&type=script&lang=js"
export * from "./ModalEditSpaceChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports